import React, { useState, useEffect } from 'react'
import cn from 'classnames'
import AutosizeInput from 'react-input-autosize'

import styles from './detail.module.css'

function DetailItem({
  value,
  label,
  predicate = (val) => val,
  editable,
  updateHandler,
  placeholder,
  className,
  ...props
}) {
  const isArray = Array.isArray(value)
  const hasValue = value ? (isArray ? value.length > 0 : true) : false
  const [editableValue, setEditableValue] = useState(value)
  const [isDirty, setDirty] = useState(false)

  useEffect(() => {
    if (editable) {
      setEditableValue(value)
    }
  }, [editable, value])

  useEffect(() => {
    setDirty(editableValue !== value)
  }, [editableValue, value])

  if (editable) {
    const handler = () => updateHandler(editableValue)
    return (
      <p className={cn(styles.mainText, className)} {...props}>
        <span className={styles.label}>{label}</span>:{' '}
        <AutosizeInput
          placeholder={placeholder || label}
          placeholderIsMinWidth={false}
          type="text"
          value={editableValue}
          onChange={(e) => setEditableValue(e.target.value)}
          onKeyDown={(e) => {
            if (e.keyCode === 13) {
              e.preventDefault()
              handler()
              e.target.blur()
            }
          }}
          inputClassName={cn(styles.editableInput, {
            [styles.dirty]: isDirty,
          })}
        />
        {isDirty && (
          <button className={styles.editableButton} onClick={handler}>
            Update
          </button>
        )}
      </p>
    )
  }

  return hasValue ? (
    <p className={cn(styles.mainText, className)} {...props}>
      <span className={styles.label}>{label}:</span>{' '}
      {isArray
        ? value.map(predicate).map((val, index) => (
            <React.Fragment key={`${val}_${index}`}>
              <span>{val}</span>
              {index < value.length - 1 ? ', ' : ''}
            </React.Fragment>
          ))
        : value}
    </p>
  ) : null
}

export default DetailItem
